import Axios from "../../configs/axios.config";

export const createSession = (data) => Axios.post(`/session`, data).then(response=>response.data.data);
export const updateSession = (data, id) => Axios.put(`/session/${id}`, data).then(response=>response.data.data);
export const getSessionList = (data) => Axios.get('/session', { params: data }).then(response=>response.data.data);
export const getSessionDetail = (id) => Axios.get(`/session/${id}`).then(response=>response.data.data);
export const deleteSession = (id) => Axios.delete(`/session/${id}`);
